import type { StateCreator } from 'zustand';

import type { UploadSlice } from './types';

export type { UploadSlice } from './types';

export const uploadInitialState = {
  pendingUploads: [] as { id: string; file: File }[],
};

export const createUploadSlice: StateCreator<
  UploadSlice,
  [],
  [],
  UploadSlice
> = (set) => ({
  ...uploadInitialState,

  addPendingUpload: (upload) =>
    set((state) => ({
      pendingUploads: [
        ...state.pendingUploads.filter((u) => u.id !== upload.id),
        upload,
      ],
    })),
  clearPendingUploads: () => set({ pendingUploads: [] }),
});
